<template>
  <div class="jiejuefangan home baozhang service_ruzhu">
    <div id="nav" class="header">
      <head-top></head-top>
      <div class="default-title">
        <div class="default-title-top">加入服务商团队 合作共赢</div>
        <div class="default-title-bottom">
          优质的产品 完善的服务 聚师傅诚邀加盟
        </div>
      </div>
    </div>

    <div class="fangan-main">
      <div class="ruzhu-tuandui">
        <div class="fangan-problem">
          <div class="fangan-problem-items">
            <div
              class="fangan-problem-item"
              v-for="(item, index) in problemList"
              :key="index"
            >
              <div style="height:140px;margin-top:10px;"></div>
              <svg class="icon hide-icon" aria-hidden="true">
                <use :xlink:href="'#' + item.icon" />
              </svg>
              <svg class="icon hover-icon" aria-hidden="true">
                <use :xlink:href="'#' + item.hover" />
              </svg>
              <div class="fangan-problem-title">{{ item.title }}</div>
              <div class="fangan-problem-content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="ruzhu-process">
        <div class="fangan-title">服务商入驻流程</div>
        <div class="ruzhu-process-info">
          <div
            class="process-box"
            v-for="(item, index) in stepsList"
            :key="index"
          >
            <div class="process-border">
              <span class="ruzhu-process-stepnum">{{ index + 1 }}</span>
              <div class="process-ball">{{ item }}</div>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconjiantou" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="ruzhu-team">
        <div class="ruzhu-team-info">
          <div
            class="ruzhu-team-left"
            :class="{ 'ruzhu-team-left-enterprise': ruzhuTeam[1].isSelected }"
          >
            <div class="ruzhu-consultation">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconzaixianzixun" />
              </svg>
              <span>在线咨询</span>
            </div>
            <div class="fangan-title">加入服务商团队</div>
            <div class="ruzhu-tabs">
              <div
                class="ruzhu-tab"
                v-for="(item, index) in ruzhuTeam"
                :key="index"
                @click="ruzhuTeamCheck(item)"
                :class="{ selected: item.isSelected }"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="ruzhu-personal" v-if="ruzhuTeam[0].isSelected">
              <div class="ruzhu-label">
                <div class="ruzhu-label-name"><span>*</span>姓名</div>
                <el-input
                  v-model="serviceData.contactName"
                  placeholder="请输入姓名"
                  class="default-input"
                ></el-input>
              </div>
              <div class="ruzhu-label">
                <div class="ruzhu-label-name"><span>*</span>电话</div>
                <el-input
                  v-model="serviceData.contactTel"
                  maxlength="11"
                  placeholder="请输入电话号码"
                  class="default-input"
                ></el-input>
              </div>
              <div class="ruzhu-label">
                <div class="ruzhu-label-name">地址</div>
                <el-select
                  v-model="citys.province"
                  @change="getCityList('province')"
                  placeholder="省"
                  class="default-input ruzhu-city"
                >
                  <el-option
                    v-for="item in allProvinceList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="citys.city"
                  @change="getCityList('city')"
                  :disabled="citys.province == ''"
                  placeholder="市"
                  class="default-input ruzhu-city"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="serviceData.contactAddressCode"
                  :disabled="citys.city == ''"
                  placeholder="区/县"
                  class="default-input ruzhu-city"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </div>
              <div class="ruzhu-label address">
                <div class="ruzhu-label-name"></div>
                <el-input
                  v-model="serviceData.detailAddress"
                  placeholder="请输入详细地址"
                  class="default-input"
                ></el-input>
              </div>
              <div class="ruzhu-label ruzhu-category">
                <div class="ruzhu-label-name">
                  <span>*</span>代理类目（可多选）
                </div>
                <div class="category-list">
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox
                      v-for="(item, index) in categoryList"
                      :label="item.id"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
              </div>
              <div class="ruzhu-label remarks">
                <div class="ruzhu-label-name">备注</div>
                <el-input
                  v-model="serviceData.remark"
                  placeholder="请输入备注内容"
                  class="default-input"
                  type="textarea"
                ></el-input>
              </div>
              <div class="ruzhu-label submit">
                <div class="ruzhu-label-name"></div>
                <el-button
                  class="ruzhu-tijiao"
                  :disabled="joinBtn"
                  @click="joinService()"
                  >提交</el-button
                >
              </div>
            </div>
            <div class="ruzhu-enterprise" v-if="ruzhuTeam[1].isSelected">
              <div class="ruzhu-label">
                <div class="ruzhu-label-name"><span>*</span>公司名称</div>
                <el-input
                  v-model="serviceData.companyName"
                  placeholder="请输入公司名称"
                  class="default-input"
                ></el-input>
              </div>

              <div class="ruzhu-label">
                <div class="ruzhu-label-name">公司地址</div>
                <el-select
                  v-model="citys.province"
                  @change="getCityList('province')"
                  placeholder="省"
                  class="default-input ruzhu-city"
                >
                  <el-option
                    v-for="item in allProvinceList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="citys.city"
                  @change="getCityList('city')"
                  :disabled="citys.province == ''"
                  placeholder="市"
                  class="default-input ruzhu-city"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="serviceData.companyAddressCode"
                  :disabled="citys.city == ''"
                  placeholder="区/县"
                  class="default-input ruzhu-city"
                >
                  <el-option
                    v-for="item in areaList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </div>
              <div class="ruzhu-label address">
                <div class="ruzhu-label-name"></div>
                <el-input
                  v-model="serviceData.companyAddress"
                  placeholder="请输入详细地址"
                  class="default-input"
                ></el-input>
              </div>
              <div class="ruzhu-label">
                <div class="ruzhu-label-name"><span>*</span>姓名</div>
                <el-input
                  v-model="serviceData.contactName"
                  placeholder="请输入姓名"
                  class="default-input"
                ></el-input>
              </div>
              <div class="ruzhu-label">
                <div class="ruzhu-label-name"><span>*</span>电话</div>
                <el-input
                  v-model="serviceData.contactTel"
                  maxlength="11"
                  placeholder="请输入电话号码"
                  class="default-input"
                ></el-input>
              </div>

              <div class="ruzhu-label ruzhu-category">
                <div class="ruzhu-label-name">
                  <span>*</span>代理类目（可多选）
                </div>
                <div class="category-list">
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox
                      v-for="(item, index) in categoryList"
                      :label="item.id"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
              </div>
              <div class="ruzhu-label remarks">
                <div class="ruzhu-label-name">备注</div>
                <el-input
                  v-model="serviceData.remark"
                  placeholder="请输入备注内容"
                  class="default-input"
                  type="textarea"
                ></el-input>
              </div>
              <div class="ruzhu-label submit">
                <div class="ruzhu-label-name"></div>
                <el-button
                  class="ruzhu-tijiao"
                  :disabled="joinBtn"
                  @click="joinService()"
                  >提交</el-button
                >
              </div>
            </div>
          </div>
          <div class="ruzhu-team-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
export default {
  components: {
    headTop
  },
  data() {
    return {
      problemList: [
        {
          icon: "icondingdanqudaoguang_nor",
          hover: "icondingdanqudaoguang_hov",
          title: "订单渠道广",
          content:
            "聚师傅与淘宝、京东等一流大平台电商渠道达成合作，线下家居用户在线下单等"
        },
        {
          icon: "iconfazhanfuchi_nor",
          hover: "iconfazhanfuchi_hov",
          title: "发展扶持",
          content: "聚师傅建立专项扶持资金，对需要扶持的地区提供人力物力支持"
        },
        {
          icon: "icongaoshouyi_nor",
          hover: "icongaoshouyi_hov",
          title: "高收益",
          content:
            "零加盟费，低投入，高收益，加盟后成为区域独家代理人，加盟区域的每笔订单均获取分红"
        },
        {
          icon: "iconpingtaizhichi_nor",
          hover: "iconpingtaizhichi_hov",
          title: "平台支持",
          content:
            "标准的运作管理支持 - 优秀的服务商分享强大的信息系统支撑 - 聚师傅接单系统"
        }
      ],
      checkList: [],
      stepsList: ["入驻咨询", "资料提交", "平台审核", "服务培训"],
      ruzhuTeam: [
        { name: "个人入驻", isSelected: true },
        { name: "企业入驻", isSelected: false }
      ],
      input: "",
      city: "",
      categoryList: [],
      allProvinceList: [],
      areaList: [],
      cityList: [],
      citys: {
        province: "",
        city: "",
        area: ""
      },
      serviceData: {
        contactName: "",
        contactTel: "",
        contactAddressCode: "",
        detailAddress: "",
        companyName: "",
        companyAddressCode: "",
        companyAddress: "",
        goodsTypeIds: "",
        remark: ""
      },
      joinBtn: false
    };
  },
  mounted() {
    this.getProvinceList();
    this.getGoodsType();
  },
  methods: {
    ruzhuTeamCheck(item) {
      for (let i of this.ruzhuTeam) {
        i.isSelected = false;
      }
      item.isSelected = true;
    },
    // 加入服务商团队
    joinService() {
      this.$message.closeAll();
      this.joinBtn = true;
      let myreg = /^1[123456789]\d{9}$/;
      let goodsTypeIds = [];
      if (this.ruzhuTeam[1].isSelected) {
        if (this.serviceData.companyName == "") {
          this.$message.error("请输入公司名称");
          this.joinBtn = false;
          return;
        }
      }
      if (this.serviceData.contactName == "") {
        this.$message.error("请输入您的姓名");
        this.joinBtn = false;
        return;
      }
      if (!myreg.test(this.serviceData.contactTel)) {
        this.$message.error("请输入合法手机号");
        this.joinBtn = false;
        return;
      }
      // for (let i of this.categoryList) {
      //   if (i.isSelected) {
      //     goodsTypeIds.push(i.id);
      //   }
      // }
      // console.log(goodsTypeIds)
      if (this.checkList.length == 0) {
        this.$message.error("请选择代理类目");
        this.joinBtn = false;
        return;
      }
      this.$post(`/user/api/service_settle_in/add`, {
        type: this.ruzhuTeam[0].isSelected ? "PERSONAL" : "ENTERPRISE",
        companyName: this.serviceData.companyName,
        companyAddressCode: this.serviceData.companyAddressCode,
        companyAddress: this.serviceData.companyAddress,
        contactName: this.serviceData.contactName,
        contactTel: this.serviceData.contactTel,
        contactAddressCode: this.serviceData.contactAddressCode,
        detailAddress: this.serviceData.detailAddress,
        remark: this.serviceData.remark,
        goodsTypeIds: this.checkList
      }).then(res => {
        if (res.code == 0) {
          this.$alert("请保持手机畅通，平台将会尽快与您联系","提交成功", {
            confirmButtonText: "确定",
            type: "success"
          }).then(() => {
            for (let i in this.serviceData) {
              this.serviceData[i] = "";
            }
            for (let i in this.citys) {
              this.citys[i] = "";
            }
            this.checkList = [];
            this.$router.push({path:"/"})
          });
          this.joinBtn = false;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 获取类目
    getGoodsType() {
      this.$fetch(`/common/api/goods_type/top_class`).then(res => {
        if (res.code == 0) {
          for (let i of res.data) {
            i.isSelected = false;
          }
          this.categoryList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 类目选择
    categoryChoice(item) {
      item.isSelected = !item.isSelected;
    },
    // 获取所有省code
    getProvinceList() {
      this.$fetch(`/common/api/area/all_province`).then(res => {
        if (res.code == 0) {
          this.allProvinceList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 根据省code获取市区数据
    getCityList(tag) {
      this.$fetch(`/common/api/area/area_children`, {
        parentCode: tag == "province" ? this.citys.province : this.citys.city
      }).then(res => {
        if (res.code == 0) {
          if (tag == "city") {
            this.areaList = res.data;
            this.citys.area = "";
          } else {
            this.cityList = res.data;
            this.citys.city = "";
            this.citys.area = "";
          }
        } else {
          this.$message(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.service_ruzhu.home {
  margin-bottom: 0;
}
.service_ruzhu {
  #nav {
    background: url("../../assets/img/fu_banner.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    height: 500px;
    .head-rightBottom {
      .service_ruzhu {
        border-bottom: 2px solid #fff;
      }
    }
  }
  .fangan-main {
    margin-top: 0;
    .fangan-problem {
      margin-top: -100px;

      .fangan-problem-items {
        margin-top: 0px;
        box-shadow: 0px 5px 14px 0px rgba(18, 31, 80, 0.08);

        .fangan-problem-item {
          width: 300px;
          height: 400px;
          margin-right: 0;
          background: #fff;
          transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
          transition-duration: 400ms;
          .icon {
            width: 140px;
            height: 140px;
            left: 26.7%;
            top: 30px;
          }
          .fangan-problem-title {
            margin-top: 30px;
          }
          .fangan-problem-content {
            margin-top: 20px;
            padding: 0 50px;
          }
        }
        .fangan-problem-item:hover {
          box-shadow: none;
          margin-top: -20px;
          color: #fff;
          background: #3455d3;
          height: 420px;
          .fangan-problem-title,
          .fangan-problem-content {
            color: #fff;
          }
        }
      }
    }
    .process-box {
      margin-right: 80px;
    }
    .process-box:last-child {
      margin-right: 0;
    }
    .process-border {
      .icon {
        right: -75px;
      }
      span {
        top: 18px;
      }
    }
    .ruzhu-team {
      // height: 825px;
      background: #f5f7fc;
      margin-top: 182px;
      overflow: hidden;
      padding-bottom: 105px;
      .ruzhu-team-info {
        width: 1200px;
        min-height: 655px;
        margin: 0 auto;
        margin-top: 50px;
        display: flex;
        .ruzhu-team-left-enterprise {
          padding: 40px 95px 20px 115px !important;
        }
        .ruzhu-team-left {
          background: #fff;
          width: 600px;
          padding: 40px 115px 20px 115px;
          position: relative;
          .ruzhu-consultation {
            width: 50px;
            height: 50px;
            position: absolute;
            color: #909399;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            top: 31px;
            left: 20px;
            display: none;
            cursor: pointer;
            .icon {
              width: 29px;
              height: 29px;
            }
            span {
              height: 12px;
              line-height: 1;
            }
          }
          //   .ruzhu-consultation:hover{
          //       .icon{
          //           color: #3455d3;
          //       }
          //       color: #3455d3;
          //   }
          .fangan-title {
            height: 32px;
            line-height: 1;
            text-align: left;
          }

          .ruzhu-tabs {
            display: flex;
            margin-top: 50px;
            height: 14px;
            line-height: 1;
            .ruzhu-tab {
              margin-right: 48px;
              cursor: pointer;
              font-size: 14px;
              position: relative;
              color: #5e6066;
              z-index: 1;
            }
            .selected {
              color: #2f3133;
              font-weight: bold;
            }
            .selected:after {
              content: "";
              position: absolute;
              height: 10px;
              background: #d8e0ff;
              width: calc(100% + 24px);
              left: -13px;
              top: 9px;
              z-index: -1;
            }
          }
          .ruzhu-personal,
          .ruzhu-enterprise {
            margin-top: 35px;
          }
          .ruzhu-enterprise {
            .ruzhu-label {
              .ruzhu-label-name {
                width: 54px;
              }
            }
            .category-list {
              margin-left: 66px;
            }
          }
          .ruzhu-label {
            display: flex;
            align-items: center;
            margin-top: 16px;
            .default-input {
              width: 212px;
              input {
                border-radius: 0;
                width: 100%;
              }
            }
            .ruzhu-city {
              width: 100px;
              margin-right: 12px;
              .el-input__suffix {
                width: auto;
              }
            }
            .ruzhu-city:last-child {
              margin-right: 0;
            }
            .ruzhu-label-name {
              font-size: 12px;
              color: #5e6066;
              margin-right: 16px;
              width: 30px;
              text-align: right;
              span {
                color: #f75658;
              }
            }
          }
          .address {
            margin-top: 10px;
            .default-input {
              width: 324px;
            }
          }
          .ruzhu-category {
            display: block;
            margin-top: 24px;
            .ruzhu-label-name {
              width: auto !important;
              text-align: left;
            }
          }
          .remarks {
            .ruzhu-label-name {
              margin-top: -50px;
            }
            .default-input {
              width: 324px;
              height: 80px;
            }

            textarea {
              resize: none;
              width: 100%;
              height: 100%;
              border-radius: 0;
              font-size: 12px;
            }
            textarea::placeholder {
              font-size: 12px;
            }
          }
          .submit {
            margin-top: 30px;
            .ruzhu-tijiao {
              width: 324px;
              height: 40px;
              background: rgba(52, 85, 211, 1);
              border-radius: 0;
              padding: 0;
              font-size: 14px;
              color: #fff;
              border-color: rgba(52, 85, 211, 1);
            }
          }
          .category-list {
            width: 324px;
            margin-left: 46px;
            // margin-top: 12px;
            display: flex;
            flex-wrap: wrap;
            .category-item {
              // width: 72px;
              height: 30px;
              border-radius: 2px;
              border: 1px solid rgba(190, 192, 198, 1);
              font-size: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #5e6066;
              margin-right: 12px;
              cursor: pointer;
              padding: 0 15px;
              margin-top: 12px;
            }
            .selected {
              color: #3455d3;
              border-color: #3455d3;
            }
            .category-item:hover {
              color: #3455d3;
              border-color: #3455d3;
            }
            .category-item:last-child {
              margin-right: 0;
            }
          }
          .ruzhu-label:nth-child(1) {
            margin-top: 0;
          }
        }
        .ruzhu-team-right {
          width: 600px;
          height: auto;
          background: url("../../assets/img/fu_banner2.jpg") no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.category-list {
  &/deep/.el-checkbox {
    margin-right: 25px;
    margin-top: 14px;
  }
}
</style>
